import { ImportTouchDesk } from 'lib/modules/ImortTouchDesk'
import PropTypes from 'prop-types'
import React, { forwardRef } from 'react'

const PageContainer = forwardRef((props, ref) => {
  return (
    <ImportTouchDesk
      touch={() => import('./layout/PageContainer.mobile')}
      desktop={() => import('./layout/PageContainer.desktop')}
    >
      {Component => <Component {...props} ref={ref} />}
    </ImportTouchDesk>
  )
})
export default PageContainer
PageContainer.propTypes = {
  headerProps: PropTypes.shape({
    rightComponent: PropTypes.node
  })
}
